import React from 'react';
import { Trans } from 'react-i18next';
import { ROUTE } from 'constants/route';
import { RIGHTS } from 'constants/rights';
import ButtonAdd from 'components/ButtonAdd';

const Actions = () => (
  <ButtonAdd
    size="small"
    to={ROUTE.POSITION_DETAIL.replace(':recordId', 'new')}
    right={RIGHTS.POSITION.ADD}
  >
    <Trans>POSITION.NEW</Trans>
  </ButtonAdd>
);

export default Actions;
